/* Clients search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';

export interface ISearchFiltersClientsState {
    keyword: string;
}

const initialState: ISearchFiltersClientsState = {
    keyword: '',
};

export function searchFiltersClientsReducer(state: ISearchFiltersClientsState = initialState, action: any): ISearchFiltersClientsState {
    switch (action.type) {
        case Actions.SEARCH_CLIENTS_KEYWORD:
            return _.merge({}, state, { keyword: action.keyword });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersClientsReducer.tsx